import React, { useState } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import { toast } from "react-toastify";
import tw from "tailwind-styled-components";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import { useTranslation } from "react-i18next";
import { Page, Underline, BoxContainer } from "../../Components/Styles/PageStyles";

const ImportAssociations = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const postFunction = async (file) => {
    if (file !== null && file !== undefined) {
      const body = new FormData();
      body.append("file", file);

      return await axios.post(`${Config.apiUrl}/importassociations`, body, {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    } else throw Error("error");
  };

  const onSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");
      navigate("/dashboard");
      setFile(null);
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
  };

  const onError = (data) => {
    toast.error(
      data?.response?.data?.msg || "An error occurred while uploading the file."
    );
  };

  const { isLoading: uploadLoading, mutate: uploadExcelFile } = useMutation(
    postFunction,
    { onSuccess, onError }
  );

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.type === "text/csv") {
        setFile(selectedFile);
        setError("");
      } else {
        setError("Only CSV files are allowed.");
        setFile(null);
      }
    }
  };

  const handleFileUpload = () => {
    if (!file) {
      setError("Please select a CSV file before uploading.");
      return;
    }

    uploadExcelFile(file);
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <TitleImport>{t("ImportAssociations")}</TitleImport>
              <Underline />
            </div>
          </div>
          <Container>
            <Header>
              <Title>Upload Your File</Title>
            </Header>
            <SubHeader>
              <Description>
                Select a CSV file containing your data to import.
              </Description>
              <Link
                href="http://sarstz.think-straight.com/api/upload/Application_CSV/userList1.csv"
                download
              >
                Download Sample File (.csv)
              </Link>
            </SubHeader>
            <InputWrapper>
              <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                className="hidden"
                id="fileInput"
              />
              <label htmlFor="fileInput">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-12 h-12 text-gray-400"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 16l-4-4m0 0l4-4m-4 4h16m-6 4V8a4 4 0 10-8 0v8m6 4H6"
                  />
                </svg>
                <span className="text-gray-500 mt-4">
                  Drag & drop a file here or click to select
                </span>
              </label>
            </InputWrapper>
            {file && <SuccessMessage>Selected File: {file.name}</SuccessMessage>}
            {error && <ErrorMessage>{error}</ErrorMessage>}
            <UploadWrapper>
              <Button onClick={handleFileUpload} disabled={uploadLoading}>
                {uploadLoading ? "Uploading..." : "Upload CSV"}
              </Button>
            </UploadWrapper>
          </Container>
        </BoxContainer>
      </Page>
    </>
  );
};

const Container = tw.div`max-w-6xl bg-white shadow-lg rounded-lg p-6 my-10 overflow-auto`;
// const Container = tw.div`max-w-6xl my-10 overflow-auto`;
const Header = tw.div`flex justify-center items-center mb-6`;
const Title = tw.h1`text-2xl font-semibold text-gray-800 text-center`;
const TitleImport = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const SubHeader = tw.div`flex justify-between items-center mb-4`;
const Description = tw.p`text-gray-600`;
const Link = tw.a`text-teal-600 hover:underline text-sm font-medium`;
const InputWrapper = tw.div`border-2 border-dashed border-gray-300 p-8 rounded-md flex flex-col items-center justify-center cursor-pointer`;
const UploadWrapper = tw.div`mt-6 flex justify-center`;
const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10 text-sm font-medium rounded shadow`;
const ErrorMessage = tw.p`text-red-500 mt-4 text-center`;
const SuccessMessage = tw.p`text-green-500 mt-4 text-center`;

export default ImportAssociations;
